<template>
	<div style="margin: 10px;">
		<el-row>
			<el-col :spa="24">
				<el-card class="box-card">
					<h4 class="title">参数信息</h4>
					<el-form ref="form" :model="form" label-width="120px" :rules="rules">
						<el-form-item label="图片" prop="pic">
							<!-- <el-input readonly v-model="form.pic" style="width:30%;float: left;"></el-input> -->
							<el-upload drag  list-type="picture-card" action="" multiple :limit="1" :file-list="fileList" :before-upload="beforePic"
							 :on-remove="RemovePic" :on-exceed="handlePic" style="width: auto;float: left;">
								<i class="el-icon-picture-outline"></i>
							<br />
							<span class="uploadTip">将图片拖到此处，或点击上传</span>
							</el-upload>
							<input type="button" size="mini" class="bullet" style="display: inline-block;margin-top:5px;margin-right: 10px;" @click.stop="picBook = 1,dialogVisible = true"
							 value="素材库选择">
							 <div class="clear"></div>
							 <span class="picTip" style="display: block;">封面图（支持JPG、JPEG、PNG图片大小限制120K）</span>
						</el-form-item>
						<el-form-item label="栏目" prop="column">
							<el-input v-model="form.column" style="width: 30%;" placeholder="添加栏目名称" @click.native="getColumn" readonly></el-input>
						</el-form-item>
						<el-form-item label="名称" prop="title">
							<el-input v-model="form.title" style="width: 30%;"></el-input>
						</el-form-item>
						<el-form-item label="链接" prop="link">
							<el-input v-model="form.link" style="width:30%"></el-input>
						</el-form-item>
						<el-form-item>
							<input type="button" @click="onSubmit('form')" class="submit" value="提交">
						</el-form-item>
					</el-form>
				</el-card>
			</el-col>
		</el-row>
		<!-- 素材库选择 -->
		<el-dialog title="素材库选择" :visible.sync="dialogVisible" width="50%" >
			<files @selectPic ="selectPic"></files>
		</el-dialog>
		<el-dialog title="栏目选择" :visible.sync="dialogColumnVisible" width="50%">
			<span class="select">您已选择:{{form.column}}</span>
			<el-tree :data="data" show-checkbox node-key="id" :props="defaultProps" :default-checked-keys="selectCId" ref="tree"
			 @check="handleNodeClick">
			</el-tree>
		</el-dialog>
	</div>
</template>

<script>
	import request from '../../../assets/js/request.js'
	import files from '../../../components/picFile.vue'
	import qs from 'qs'
	export default {
		components: {
			files
		},
		data() {
			return {
				form: {
					title: '',
					link: '',
					pic: '',
					imagesThumb: '',
					id: '',
					column: [],
				},
				rules: {
					pic: [{
						required: true,
						message: '请输入图片',
						trigger: 'blur'
					}],
					
				},
				fileList: [],
				dialogVisible:false,
				dialogColumnVisible: false,
				defaultProps: {
					children: 'childRpColum',
					label: 'columname'
				},
				loading: false,
				selectCId: [],
				data:[]
			}
		},
		created() {
			if (this.$route.query.iden == 'update') {
				this.form.pic = this.$route.query.rows.images
				this.form.imagesThumb = this.$route.query.rows.imagesThumb
				this.form.title = this.$route.query.rows.title
				this.form.link = this.$route.query.rows.website
				this.form.id = this.$route.query.rows.id
				this.selectCId = this.$route.query.rows.column.split(',')
				this.form.column = this.$route.query.rows.columns
				this.fileList.push({url:this.settings.apiBaseImg + this.$route.query.rows.images})
			}
		},
		methods: {
			//获取栏目
			getColumn() {
				this.dialogColumnVisible = true
				var obj = this;
				obj.$http({
					method: 'get',
					url: 'api/v1/column/list',
					params: {
						uid: localStorage.getItem('uid')
					},
				}).then((res) => {
					if (res.status == 200) {
						this.data=res.data.data
						this.data.push({
							id:0,
							columname:'首页'
						})
					} else {
						obj.$message.error(res.data.msg)
					}
				})
			},
			//选择栏目
			handleNodeClick() {
				this.selectCId = this.$refs.tree.getCheckedKeys().concat(this.$refs.tree.getHalfCheckedKeys())
				var arr = []
				for (var i = 0; i < this.$refs.tree.getCheckedNodes().length; i++) {
					arr.push(this.$refs.tree.getCheckedNodes()[i].columname)
				}
				this.form.column = arr.join(',')
			},
			//添加提交
			onSubmit(formName) {
				if (this.$route.query.iden == 'add') {
					this.$refs[formName].validate((valid) => {
						if (valid) {
							var obj = this
							obj.$http({
								method: 'post',
								url: 'api/v1/wbanner/add',
								data: {

									title: this.form.title,
									website: this.form.link,
									images: this.form.pic,
									imagesThumb: this.form.imagesThumb,
									column: this.selectCId.toString(),
								},
							}).then((res) => {
								if (res.data.status == 200) {
									this.$message.success('添加成功');
									this.$router.push({
										path: '/home/phone'
									})
								} else {
									this.$message.error(res.data.message);
								}
							})
						} else {
							console.log('error submit!!');
							return false;
						}
					});
				} else {
					this.onUpdate(formName)
				}
			},
			onUpdate(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						var obj = this
						obj.$http({
							method: 'post',
							url: 'api/v1/wbanner/edit',
							data: {
								id: this.form.id,
								title: this.form.title,
								website: this.form.link,
								images: this.form.pic,
								imagesThumb: this.form.imagesThumb,
								column: this.selectCId.toString(),
							},
						}).then((res) => {
							if (res.data.status == 200) {
								this.$message.success('修改成功');
								this.$router.push({
									path: '/home/phone'
								})
							} else {
								this.$message.error(res.data.message);
							}
						})
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			beforePic(file, fileList) {
				let objUrl = file;
				let formData = new FormData();
				formData.append('file', objUrl);
				formData.append('uid', localStorage.getItem('uid'));
				var obj = this;
				obj.$http({
					method: 'post',
					url: 'api/v1/news/upload',
					data: formData,
				}).then((res) => {
					if (res.status == 200) {
						obj.$message.success(res.data.message)
						this.form.pic = res.data.data.images
						this.form.imagesThumb = res.data.data.imagesThumb
						this.fileList=[]
						this.fileList.push({url:this.settings.apiBaseImg + res.data.data.imagesThumb})
					} else {
						obj.$message.error(res.data.message)
					}
				})
			},
			//素材库选择图片
			selectPic(index, rows) {
				this.fileList=[]
				this.fileList.push({url:this.settings.apiBaseImg + rows.path})
					this.form.pic = rows.path
					this.form.imagesThumb = rows.path
					this.dialogVisible = false
				
			},
			RemovePic() {
				this.form.pic = ''
			},
			handlePic(files, fileList) {
				this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
			},
		}
	}
</script>

<style scoped="scoped">
	.title {
		margin-bottom: 40px;
	}

	/deep/ .el-input__inner {
		height: 30px;
	}

	.picTip {

		height: 16px;
		font-size: 14px;
		font-family: PingFang SC;
		font-weight: 400;
		color: #000000;
		line-height: 24px;
		opacity: 0.5;
		margin-left: 10px;
	}
</style>



// WEBPACK FOOTER //
// src/views/phone/phone/phoneAdd.vue